import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
import { download } from './exporters';
import { APP_INFO } from './license';

export const MFR_ID = 'armare-tec';
const fmt = (v, d = 1) => v.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
const head = (t) => [t.fpPos, t.rmQty, t.mfColUnit, t.mfColName, t.mfColDim, t.mfColMat, t.mfColMfr, t.mfColSku, t.mfColPrice];

export function bomXlsx(t, title, rows) {
  const aoa = [[title], [], head(t), ...rows.map((r) => [r.pos, r.qty, t['unit_' + r.unit] || r.unit, r.name, r.dim, r.mat, r.mfr || t.fpOther, r.sku, r.price ?? '']), [], [t.fpNote], [t.fpNoPrice]];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = [6, 8, 8, 50, 22, 18, 22, 14, 14].map((w) => ({ wch: w }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Stueckliste');
  const blob = new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  download(blob, `${title.replace(/[^\w-]+/g, '_')}.xlsx`);
}

export function bomPdf(t, title, pl, p, res, mfr) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' }), M = 14, W = 182, c = res.c;
  const asc = (s) => String(s).replace(/³/g, '3').replace(/²/g, '2');
  doc.setFillColor(10, 37, 64); doc.rect(0, 0, 210, 24, 'F'); doc.setFillColor(220, 38, 38); doc.rect(0, 24, 210, 2, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(14); doc.text(asc(`${t.fpOpen}: ${pl.name(t)}`), M, 11);
  doc.setFontSize(10); doc.setFont('helvetica', 'normal'); doc.text(asc(title), M, 18);
  doc.text(`${APP_INFO.publisher} · ${new Date().toLocaleDateString('de-DE')}`, 210 - M, 18, { align: 'right' });
  doc.setTextColor(20, 20, 20);
  let y = 34;
  const lab = (f) => (typeof f.label === 'function' ? f.label(t) : f.label);
  const val = (f) => { const v = p[f.k]; if (f.type === 'chk') return v ? t.fpYes : t.fpNo; if (f.type === 'sel') { const o = (typeof f.opts === 'function' ? f.opts(t) : f.opts).find(([k]) => String(k) === String(v)); return o ? o[1] : String(v ?? ''); } return v === '' || v == null ? '–' : String(v); };
  const kp = pl.kpis(t, c, (v, d = 0) => v.toLocaleString('de-DE', { maximumFractionDigits: d }));
  if (pl.fields.length) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.text(t.fpResult, M, y); y += 6;
    doc.setFontSize(9);
    [...kp.map(([k, v]) => [k, String(v), true]), ...pl.fields.map((f) => [lab(f), val(f), false])].forEach(([k, v, b], i) => {
      const yy = y + i * 4.8;
      doc.setFont('helvetica', 'normal'); doc.text(asc(doc.splitTextToSize(`${k}:`, 95)[0]), M, yy);
      doc.setFont('helvetica', b ? 'bold' : 'normal'); doc.text(asc(doc.splitTextToSize(v, 84)[0] || ''), M + 98, yy);
    });
    y += (kp.length + pl.fields.length) * 4.8 + 4;
  }
  c.warn.forEach((w) => { doc.setTextColor(200, 30, 30); doc.text(doc.splitTextToSize(asc(t[w] || w), W), M, y); y += 5; doc.setTextColor(20, 20, 20); });
  y += 2; doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.text(asc(`${t.fpBom} – ${mfr?.name || ''}`), M, y); y += 2;
  doc.setDrawColor(220, 38, 38); doc.setLineWidth(0.6); doc.line(M, y, M + W, y); y += 5;
  const cols = [M, M + 10, M + 22, M + 34, M + 120, M + 156];
  const line = (cells, bold) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(8.3);
    const nm = doc.splitTextToSize(String(cells[3]), 84), dm = doc.splitTextToSize(String(cells[4]), 34), mt = doc.splitTextToSize(String(cells[5]), 26);
    const h = Math.max(nm.length, dm.length, mt.length) * 3.7 + 1.4;
    if (y + h > 280) { doc.addPage(); y = 18; }
    [String(cells[0]), String(cells[1]), String(cells[2]), nm, dm, mt].forEach((v, i) => doc.text(v, cols[i], y));
    y += h;
  };
  line([t.fpPos, t.rmQty, t.mfColUnit, t.mfColName, t.mfColDim, t.mfColMat], true);
  res.rows.forEach((r) => line([r.pos, r.qty, t['unit_' + r.unit] || r.unit, `${r.name}${r.other ? ` (${t.fpOther})` : ''}${r.sku ? ` · ${r.sku}` : ''}${r.price != null ? ` · ${fmt(r.price, 2)} EUR` : ''}`, r.dim, r.mat]));
  y += 4; doc.setFontSize(8); doc.setTextColor(90, 90, 90);
  [t.fpNoPrice, t.fpNote, mfr ? `${mfr.name} · ${mfr.city || ''} · ${mfr.phone || ''} · ${mfr.email || ''} · ${mfr.url || ''}` : ''].filter(Boolean).forEach((s) => { const l = doc.splitTextToSize(s, W); if (y + l.length * 4 > 288) { doc.addPage(); y = 18; } doc.text(l, M, y); y += l.length * 4 + 1.5; });
  const blob = doc.output('blob');
  download(blob, `${title.replace(/[^\w-]+/g, '_')}_Stueckliste.pdf`);
  return blob;
}

// quote request e-mail without prices
export function quoteMail(t, mfr, rows, title, subj = t.fpMailSubj, hello = '') {
  const priced = !!hello;
  const body = [hello || t.fpMailHello, '', title, '', ...rows.map((r, i) => `${r.pos || i + 1}. ${r.qty} ${t['unit_' + r.unit] || r.unit} – ${r.name}${r.dim ? ` · ${r.dim}` : ''}${r.sku ? ` · ${t.mfColSku} ${r.sku}` : ''}${priced && r.price != null ? ` · ${r.price.toLocaleString('de-DE', { minimumFractionDigits: 2 })} EUR` : ''}`), '', priced ? t.dlMailBye : t.fpMailBye].join('\n');
  window.location.href = `mailto:${mfr?.email || ''}?subject=${encodeURIComponent(`${subj}${title ? ' – ' + title : ''}`)}&body=${encodeURIComponent(body)}`;
}
